export default {
  _id: '1.A1.4',
  klf: "Le Knowledge Graph vampirise 40% d'une page de résultats. Certes, toutes les requêtes ne sont pas concernées, mais si votre activité peut en profiter, vous avez là une merveilleuse vitrine !\n",
  tips: 'Un conseil : cherchez un lien entre votre activité et le Knowledge Graph.\n',
  chapter_id: '1.A1',
  authors: [],
  context: {
    title: '',
    description: '',
    media: {
      subtitles: [],
      posters: [],
      src: []
    }
  },
  meta: {
    updatedAt: '2017-05-30T13:01:53.025Z',
    createdAt: '2017-05-30T13:01:53.025Z'
  },
  lessons: [
    {
      type: 'video',
      ref: 'ref',
      poster: '//static.coorpacademy.com/content/digital/miniatures_cours/avance/1A1.png',
      description: 'Le concept de Knowledge Graph',
      mimeType: 'application/vimeo',
      mediaRef: '',
      mediaUrl:
        '//player.vimeo.com/external/89404998.m3u8?s=eaab5764b4ec57c635501c74d41ee60ca069c937&oauth2_token_id=411503075',
      downloadUrl:
        '//player.vimeo.com/external/89404998.sd.mp4?s=b1bf57bc6716d72521eba9a6517edc084566c83a&profile_id=112&oauth2_token_id=411503075',
      videoId: '89404998',
      _id: '590b862e2e967f64333ad46f',
      subtitles: [],
      posters: [],
      src: []
    }
  ],
  question: {
    type: 'qcm',
    header: "Quelle proportion du volume d'une page de résultats occupe le Knowledge Graph ?",
    explanation: 'Faites glisser le curseur.',
    content: {
      id: 'discipline_1.module_avance.chapter_1.slide_4.title',
      min: 0,
      max: 100,
      defaultValue: 0,
      unitLabel: '%\n',
      maxTypos: null,
      choices: [],
      media: {
        subtitles: [],
        posters: [],
        src: []
      },
      answers: []
    },
    medias: []
  }
};
